import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CommentIcon from "@mui/icons-material/Comment";
import MUiTextField from "components/Shared/MuiTextField";
import MCard from "components/Shared/MCard.tsx";
import { updateCaseHeader } from "actions/homeowner/caseforms";
import { updateQAReduxCaseInfo } from "actions/qualityAssurance";

class InspectionComments extends React.Component {
  constructor(props) {
    super(props);
    this.editFieldRef = React.createRef();
    this.state = {
      editing: false,
      comments: null,
    };
  }

  render() {
    const { text, className, updateCaseHeader, updateQAReduxCaseInfo, controlNumber, canUserEdit } = this.props;
    const { editing, comments } = this.state;
    return (
      <MCard
        key={text}
        title="Inspection Comments"
        className={className}
        actions={
          editing
            ? [
                {
                  icon: "check",
                  helpText: "Apply Changes",
                  order: 9000,
                  onClick: () => {
                    const comments = this.editFieldRef.current.value;
                    updateCaseHeader(controlNumber, comments);
                    updateQAReduxCaseInfo(comments);
                    this.setState({
                      editing: false,
                      comments,
                    });
                  },
                },
                {
                  icon: "close",
                  helpText: "Cancel Changes",
                  order: 9001,
                  onClick: () => this.setState({ editing: false }),
                },
              ]
            : canUserEdit
              ? [
                  {
                    icon: "edit",
                    helpText: "Edit",
                    order: 9000,
                    onClick: () => this.setState({ editing: true }),
                  },
                ]
              : []
        }
        fields={[
          {
            key: "inspection-comments",
            control: (
              <div style={{ verticalAlign: "top", display: "inline-flex", width: "calc(100% - 32px)" }}>
                {editing ? (
                  <MUiTextField
                    defaultValue={(comments || text)?.split("<br />").join("\n")}
                    inputRef={this.editFieldRef}
                    fullWidth
                    multiline
                  />
                ) : (
                  <>
                    <CommentIcon 
                      style={{ marginRight: "0.5em" }} 
                      titleAccess="Comments"
                    />
                    <div style={{ overflowWrap: "break-word", width: "100%" }}>
                      {text &&
                        (comments || text)?.split("<br />").map((item) => (
                          <span key={item}>
                            {item}
                            <br />
                          </span>
                        ))}
                    </div>
                  </>
                )}
              </div>
            ),
          },
        ]}
      />
    );
  }
}

InspectionComments.defaultProps = {
  text: "",
};

InspectionComments.propTypes = {
  text: PropTypes.string,
  controlNumber: PropTypes.number,
  canUserEdit: PropTypes.bool,
  className: PropTypes.string,
  updateCaseHeader: PropTypes.func.isRequired,
  updateQAReduxCaseInfo: PropTypes.func.isRequired,
};

const mdtp = (dispatch) => ({
  updateCaseHeader(controlNumber, inspectionComments) {
    dispatch(updateCaseHeader(controlNumber, { inspectionComments }));
  },
  updateQAReduxCaseInfo(inspectionComments) {
    dispatch(updateQAReduxCaseInfo({ inspectionComments }));
  },
});

export default connect(null, mdtp)(InspectionComments);
